module.exports = __webpack_public_path__ + "/img/SODFL-Labeled-1F3yRk.svg";